import { getCurrencySymbol } from "@/utils";

import { DurationPlanView } from "./buildDurationPlans";

// TODO(karlbernard): [NX-11136] Replace with CMS keys (subscription:page.landing.headlineWithPrice / headlineFallback) once registered.
const HEADLINE_PREFIX = "Chat from ";
const HEADLINE_SUFFIX = "/day";
const FALLBACK_HEADLINE = "Unlock unlimited chats";

function getLowestPerDayPlan(plans: readonly DurationPlanView[]): DurationPlanView | undefined {
  if (!plans.length) {
    return undefined;
  }
  return plans.reduce((lowest, plan) => (plan.perDay < lowest.perDay ? plan : lowest));
}

// Builds the hero headline ("Chat from $X/day") from the cheapest per-day plan
// (typically the annual one) so the advertised price always reflects real data
// instead of a hardcoded value.
export default function buildFromPriceHeadline(plans: readonly DurationPlanView[]): string {
  const lowestPlan = getLowestPerDayPlan(plans);
  if (!lowestPlan) {
    return FALLBACK_HEADLINE;
  }
  return `${HEADLINE_PREFIX}${getCurrencySymbol(lowestPlan.currency)}${lowestPlan.perDay.toFixed(2)}${HEADLINE_SUFFIX}`;
}
